module.exports = __webpack_public_path__ + "img/product-s618-6000.4ff84d85.png";